import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Translation, TranslocoLoader } from '@jsverse/transloco';
import { Observable } from 'rxjs';
import { MFE_BASE_URL_TOKEN } from '@client/mfe/tokens/mfe-tokens';

/**
 * Transloco loader for MFE mode.
 * Loads i18n assets from the MFE base URL instead of the shell origin.
 */
@Injectable()
export class MfeTranslocoLoader implements TranslocoLoader {
    constructor (
        private readonly http: HttpClient,
        @Inject(MFE_BASE_URL_TOKEN) private readonly baseUrl: string,
    ) {}

    getTranslation (lang: string): Observable<Translation> {
        return this.http.get<Translation>(`${this.baseUrl}/assets/i18n/${lang}.json`);
    }
}
